import React, {memo} from "react"
import {SelectModel} from "../types/types"

export const SelectButton = memo(function SelectButton(props: SelectModel) {
    const {id, name, is_selected, onClick} = props

    return (
        <button onClick={() => onClick(id)} className={`${is_selected ? "device-active-button" : ""}`}>
            {name}
        </button>
    )
})
